import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
    name: 'linkify',
    standalone: false
})
export class LinkifyPipe implements PipeTransform {
  transform(value: string): string {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    return value.replace(urlRegex, '<a href="$1" target="_blank" class="blueLink">$1</a>');
  }
}
